module.exports = __webpack_public_path__ + "img/32.47c05711.png";